import {
   Dialog
  ,DialogTitle
  ,DialogContent
  ,DialogActions
  ,useMediaQuery
} from 'external/material'
import {pickAttributes} from 'utils/style'


export default function ResponsiveDialog(props) {
  const {open, close, confirm, cancel} = props
  const fullScreen = useMediaQuery('(max-width:600px)')
  const dialogProps = pickAttributes(props, 'dialog')
  const titleProps = pickAttributes(props, 'head')
  const contentProps = pickAttributes(props, 'content')
  const actionsProps = pickAttributes(props, 'actions')
  const hasActions = !!confirm || !!cancel
  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={e => close(e)}
      {...dialogProps}
    >
      {props.title && (<DialogTitle id="responsive-dialog-title" {...titleProps}>{props.title}</DialogTitle>)}
      {props.children && (<DialogContent {...contentProps}>{props.children}</DialogContent>)}
      {hasActions && (<DialogActions {...actionsProps}>
        {cancel && cancel}
        {confirm && confirm}
      </DialogActions>)}
    </Dialog>
  )
}
